<template>
  <div class="relative" v-click-away="onClickAway">
    <div
      class="cursor-pointer rounded-full px-5 py-5 font-medium text-black-78 hover:bg-green-10 lg:px-10 lg:py-5"
      :class="wrapperClasses"
      @click="show = !show"
    >
      <div
        class="flex h-6 items-center whitespace-nowrap"
        :class="{ 'text-green': show }"
      >
        <v-icon :icon="icon" size="5" class="mr-2" v-if="icon"></v-icon>
        {{ placeholder }}
        <v-icon
          icon="chevron-down"
          size="5"
          class="ml-auto duration-150"
          :class="{ 'rotate-180': show }"
        ></v-icon>
      </div>
    </div>

    <transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div
        v-show="show"
        class="absolute left-5 top-full mt-2.5 w-80 rounded-3xl bg-white p-5 shadow-search md:w-[350px]"
      >
        <slot
          name="options"
          class="absolute left-0 top-full w-full bg-white shadow-search"
        ></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MainSearchDropdown",

  props: {
    placeholder: {
      type: String,
      default: "Išči",
    },
    icon: {
      type: String,
      default: null,
    },
    wrapperClasses: {
      type: String,
      default: "",
    },
  },

  watch: {
    placeholder() {
      // this.show = false;
    },
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    onClickAway(event) {
      this.show = false;
    },
  },
};
</script>
